module.exports = __webpack_public_path__ + "img/icon_map_8_off_011.5df498ac.png";